import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import DataTable from "@/components/DataTable";
import Modal, { Field, TextInput, Select, PrimaryButton, SecondaryButton } from "@/components/FormKit";
import { toast } from "sonner";

export default function Towers() {
  const [items, setItems] = useState([]);
  const [projects, setProjects] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ project_id: "", name: "", floors: 1, description: "" });

  const load = async () => {
    const [t, p] = await Promise.all([api.get("/company/towers"), api.get("/company/projects")]);
    setItems(t.data);
    setProjects(p.data);
  };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/company/towers", { ...form, floors: Number(form.floors) });
      toast.success("Tower created");
      setOpen(false);
      setForm({ project_id: "", name: "", floors: 1, description: "" });
      load();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  const projectName = (pid) => projects.find((p) => p.id === pid)?.name || "—";

  return (
    <div className="space-y-8" data-testid="company-towers-page">
      <PageHeader
        eyebrow="Structures"
        title="Towers"
        description="Buildings and blocks inside your projects."
        actions={<PrimaryButton onClick={() => setOpen(true)} testId="new-tower-button">+ New Tower</PrimaryButton>}
      />

      <DataTable
        testId="towers-table"
        columns={[
          { key: "name", label: "Tower", render: (r) => <div className="font-bold">{r.name}</div> },
          { key: "project_id", label: "Project", render: (r) => projectName(r.project_id) },
          { key: "floors", label: "Floors" },
          { key: "unit_count", label: "Units" },
          { key: "description", label: "Description" },
        ]}
        rows={items}
        empty="No towers yet."
      />

      <Modal open={open} onClose={() => setOpen(false)} title="New tower">
        <form onSubmit={submit}>
          <Field label="Project">
            <Select testId="form-tower-project" required value={form.project_id} onChange={(e) => setForm({ ...form, project_id: e.target.value })}>
              <option value="">Select project…</option>
              {projects.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
            </Select>
          </Field>
          <Field label="Tower name"><TextInput testId="form-tower-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></Field>
          <Field label="Floors"><TextInput testId="form-tower-floors" type="number" min="1" value={form.floors} onChange={(e) => setForm({ ...form, floors: e.target.value })} /></Field>
          <Field label="Description"><TextInput testId="form-tower-desc" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} /></Field>
          <div className="flex justify-end gap-2 pt-2">
            <SecondaryButton type="button" onClick={() => setOpen(false)}>Cancel</SecondaryButton>
            <PrimaryButton type="submit" testId="submit-tower">Create</PrimaryButton>
          </div>
        </form>
      </Modal>
    </div>
  );
}
